import { render, staticRenderFns } from "./PageMathGameScore.vue?vue&type=template&id=b877ef92&scoped=true&"
import script from "./PageMathGameScore.vue?vue&type=script&lang=js&"
export * from "./PageMathGameScore.vue?vue&type=script&lang=js&"
import style0 from "./PageMathGameScore.vue?vue&type=style&index=0&id=b877ef92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b877ef92",
  null
  
)

export default component.exports